import { signInWithEmailAndPassword } from "firebase/auth";
import {
  clearFirebaseLocalStorage,
  initFirebase,
} from "@shared/services/api/firebase";
import { apiRequest } from "@shared/services/api/apiRequest";
import { AppType } from "@shared/types/app.types";

type Args = {
  appType: AppType;
  data: any;
  onError?: (error: Error) => void;
};

export async function loginUser({ appType, data, onError }: Args) {
  // API endpoint is the same for both platform and portal
  const apiEndpoint = "/firebase-login/";

  try {
    // Ensure firebase is initialized
    const auth = await initFirebase();

    // Login user
    const userCredential = await signInWithEmailAndPassword(
      auth,
      data.email,
      data.password
    );

    // Get user
    const user = userCredential.user;

    // Get ID token
    const idToken = await user.getIdToken();

    // Prepare data for API call
    const body = { firebase_token: idToken };

    // Send data to backend
    const response = await apiRequest(apiEndpoint, "POST", body);

    return { authToken: idToken, ...response };
  } catch (error) {
    clearFirebaseLocalStorage();
    onError?.();

    throw error;
  }
}

export default loginUser;
